import { DocumentTypeV1 } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllDocumentTypes = () => getAllEnumOptions(DocumentTypeV1)

export const getDocumentTypeLabel = (key?: DocumentTypeV1) => {
  if (key === null || typeof key === 'undefined') return ''

  return DocumentTypeV1[key]
}
